/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["infinite-scroll-disabled"];
const _hoisted_2 = {
  key: 0,
  style: {
    "color": "#FFFFFF"
  }
};
const _hoisted_3 = {
  key: 1,
  style: {
    "color": "rgba(65,109,143,0.9)"
  }
};
const _hoisted_4 = {
  style: {
    "color": "#FFFFFF",
    "text-align": "center",
    "margin-top": "2rem"
  }
};
const _hoisted_5 = {
  class: "background-img-ty",
  style: {
    "padding-left": "5rem",
    "padding-top": "2.5rem",
    "height": "98%"
  }
};
const _hoisted_6 = {
  style: {
    "width": "95%",
    "height": "6rem",
    "margin-top": "0.5rem"
  },
  class: "col-4-div"
};
const _hoisted_7 = {
  style: {
    "background": "rgb(2,21,40)",
    "width": "100%",
    "border": "#1d5390 solid"
  }
};
const _hoisted_8 = {
  colspan: "2"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 1,
  colspan: "2"
};
const _hoisted_15 = ["rowspan"];
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  key: 1,
  class: "no-data"
};
import mqtt from "precompiled-mqtt";
import { getAlarmList, getPointList } from "@/api/alarm/alarmInfo";
export default {
  __name: 'detail',
  setup(__props) {
    const recentlyTaskId = inject("recentlyTaskId");
    const scrollDiv = ref(null);
    const scrollBarImg = ref(null);
    const dateRange = ref([]);
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const total = ref(0);
    let a = Date.now();
    const clientAlarm = mqtt.connect("wss://satwide.com/mqtt", {
      clientId: 'alarm' + a
    });
    const alarmData = reactive({
      alarmList: []
    });

    /*clientAlarm.on("connect", () => {
      console.log(`mqtt连接成功`)
      console.log(clientAlarm)
    });
    clientAlarm.on("message", (topic, message) => {
      if (topic.includes('alarm_real_task_'+recentlyTaskId.value)) {
        console.log("订阅到消息")
        console.log("订阅到消息1111")
        console.log(message.toString())
        //http://192.168.10.73:7788/group1/M00/06/1F/wKgKSWW8xlGAL4SQAAawuWmC06E876.jpg
        let aInfo = message.toString().replaceAll("http://192.168.10.73:7788","https://satwide.com/imgoq");
        let alarmInfo = JSON.parse(aInfo)
        console.log(alarmInfo)
        alarmData.alarmList.unshift(alarmInfo)
      }
    });*/
    const data = reactive({
      indexScroll: 0,
      detailInfo: {
        index: 0,
        show: false,
        alarmDetail: {}
      },
      form: {
        fieldTemplateList: []
      },
      formview: {
        fieldTemplateList: []
      },
      queryTree: {
        taskName: '',
        taskDate: [],
        deviceId: undefined
      },
      queryParams: {
        pageNum: 0,
        pageSize: 8,
        selectLabel: 1,
        startDate: '',
        endDate: '',
        reportLevelList: [],
        pointIdList: [],
        reportNoList: [],
        deptId: undefined,
        taskId: undefined,
        deviceId: undefined
      },
      statusOptions: [{
        value: 2,
        label: '所有'
      }, {
        value: 1,
        label: '未处理'
      }, {
        value: 0,
        label: '已处理'
      }],
      pointList: [],
      pointIdOptions: []
    });
    const loading = ref(false);
    const noMore = computed(() => data.queryParams.pageNum * data.queryParams.pageSize >= total.value);
    const disabled = computed(() => loading.value || noMore.value);
    const load = () => {
      loading.value = true;
      if (scrollDiv.value.scrollTop + scrollDiv.value.clientHeight >= scrollDiv.value.scrollHeight - 5) {
        setTimeout(() => {
          getList();
          loading.value = false;
        }, 200);
      }
    };
    /** 查询告警列表 */
    const getList = () => {
      data.queryParams.taskId = recentlyTaskId;
      data.queryParams.startDate = '';
      data.queryParams.endDate = '';
      console.log(dateRange.value);
      if (dateRange.value !== null && dateRange.value.length > 0) {
        data.queryParams.startDate = dateRange.value[0];
        data.queryParams.endDate = dateRange.value[1];
      }
      data.queryParams.pageNum++;
      getAlarmList(data.queryParams).then(res => {
        if (res.rows.length < 1) {
          data.queryParams.pageNum--;
        }
        if (alarmData.alarmList.length > 0) {
          if (res.pageNum === 1) {
            alarmData.alarmList = res.rows.concat(alarmData.alarmList);
          } else {
            alarmData.alarmList = alarmData.alarmList.concat(res.rows);
          }
        } else {
          alarmData.alarmList = res.rows;
        }
        total.value = res.total;
        data.detailInfo.alarmDetail = alarmData.alarmList[data.detailInfo.index];
      });
    };
    const getAlarmInfoListByPointIdList = () => {
      let options = [];
      data.queryParams.pointIdList = [];
      if (data.pointIdOptions.length > 0) {
        for (let pointIdListElement of data.pointIdOptions) {
          options.push(pointIdListElement[pointIdListElement.length - 1]);
        }
      }
      data.queryParams.reportNoList = options;
      data.queryParams.pageNum = 0;
      console.log(data.queryParams);
      alarmData.alarmList = [];
      getList();
    };
    const getAllPointList = () => {
      getPointList().then(response => {
        data.pointList = response.data;
      });
    };
    const handleView = index => {
      data.detailInfo.alarmDetail = alarmData.alarmList[index];
      data.detailInfo.index = index;
    };
    const moveScrollDiv = () => {
      scrollDiv.value.scrollTop = scrollDiv.value.scrollHeight * data.detailInfo.index / alarmData.alarmList.length;
      scrollBarImg.value.scrollTop = 0;
    };
    const handleScroll = e => {
      let direction = e.deltaY > 0 ? 'down' : 'up'; //deltaY为正则滚轮向下，为负滚轮向上
      let scrollBarStatus = 'top';
      if (scrollBarImg.value.scrollTop === 0) {
        scrollBarStatus = 'top';
      } else if (scrollBarImg.value.scrollTop + scrollBarImg.value.clientHeight >= scrollBarImg.value.scrollHeight - 10) {
        scrollBarStatus = 'bottom';
      } else {
        scrollBarStatus = 'middle';
      }
      if (scrollBarImg.value.clientHeight === scrollBarImg.value.scrollHeight) {
        if (direction === 'down') {
          //125为用户一次滚动鼠标的wheelDelta的值
          nextOne(2);
        }
        if (direction === 'up') {
          nextOne(3);
        }
      }
      if (direction === 'down') {
        //125为用户一次滚动鼠标的wheelDelta的值
        if (scrollBarStatus === 'bottom') {
          if (data.indexScroll > 0) {
            nextOne(2);
            data.indexScroll = 0;
          } else {
            data.indexScroll++;
          }
        }
      }
      if (direction === 'up') {
        if (scrollBarStatus === 'top') {
          if (data.indexScroll > 0) {
            nextOne(3);
            data.indexScroll = 0;
          } else {
            data.indexScroll++;
          }
        }
      }
    };
    let isMethodCalled = false;
    const nextOne = i => {
      //直接下移一个位置 3直接上移一个位置
      if (i === 2) {
        if (data.detailInfo.index === alarmData.alarmList.length - 1) {
          if (data.queryParams.pageNum * data.queryParams.pageSize >= total.value) {
            if (!isMethodCalled) {
              proxy.$modal.notify("已经是最后一条数据了");
              isMethodCalled = true;
              setTimeout(() => {
                isMethodCalled = false;
              }, 5000);
            }
            return;
          } else {
            getList();
          }
        }
        data.detailInfo.index++;
      } else if (i === 3) {
        if (data.detailInfo.index === 0) {
          if (!isMethodCalled) {
            proxy.$modal.notify("已经是第一条数据了");
            isMethodCalled = true;
            setTimeout(() => {
              isMethodCalled = false;
            }, 5000);
          }
          return;
        }
        data.detailInfo.index--;
      }
      data.detailInfo.alarmDetail = alarmData.alarmList[data.detailInfo.index];
      moveScrollDiv();
    };
    const refresh = () => {
      getAlarmInfoListByPointIdList();
    };
    onMounted(() => {
      getAllPointList();
      getList();

      /*  clientAlarm.subscribe('alarm_real_task_'+recentlyTaskId.value, {qos: 2}, () => {
          console.log(`订阅了告警消息`+'alarm_real_task_'+recentlyTaskId.value)
        });*/
    });
    onUnmounted(() => {
      console.log("页面关闭");
      /*  clientAlarm.end(true,{},()=>{
          console.log("关闭mqttclient")
        })*/
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "更新",
        placement: "top",
        "auto-close": 500
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          circle: "",
          icon: "Refresh",
          onClick: _cache[0] || (_cache[0] = $event => refresh()),
          class: "satpro-button update_button"
        })]),
        _: 1
      }), _createElementVNode("div", null, [_createVNode(_component_el_row, {
        gutter: 48
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          style: {
            "height": "60rem"
          },
          span: 5,
          xs: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            class: "searchtitle",
            label: "类别",
            prop: "pointIdList"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: _unref(data).pointIdOptions,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(data).pointIdOptions = $event),
              size: 'default',
              style: {
                "width": "23rem"
              },
              "show-all-levels": false,
              clearable: "",
              "collapse-tags": true,
              options: _unref(data).pointList,
              props: {
                multiple: true
              },
              onChange: getAlarmInfoListByPointIdList
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }), _createElementVNode("div", {
            ref_key: "scrollDiv",
            ref: scrollDiv,
            class: "gaojingtoprlist",
            onWheel: load,
            style: {
              "overflow": "auto"
            },
            "infinite-scroll-disabled": _unref(disabled)
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alarmData).alarmList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_image, {
              onClick: $event => handleView(index),
              class: _normalizeClass({
                active: _unref(data).detailInfo.alarmDetail._id === item._id
              }),
              key: index,
              src: item.recognitionUrl,
              alt: item._id
            }, null, 8, ["onClick", "class", "src", "alt"]);
          }), 128)), _unref(loading) ? (_openBlock(), _createElementBlock("p", _hoisted_2, "加载中...")) : _createCommentVNode("", true), _unref(noMore) && _unref(alarmData).alarmList.length > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_3, "没有更多了！")) : _createCommentVNode("", true)], 40, _hoisted_1), _createElementVNode("p", _hoisted_4, "告警总数：" + _toDisplayString(_unref(total)), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          style: {
            "height": "66rem"
          },
          span: 19,
          xs: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_unref(total) > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "scrollBarImg",
            ref: scrollBarImg,
            onWheel: handleScroll,
            class: "scrollBarStyle",
            style: {
              "overflow": "auto"
            }
          }, [_createVNode(_component_el_image, {
            style: {
              "width": "95%",
              "height": "52rem"
            },
            src: _unref(data).detailInfo.alarmDetail.recognitionUrl
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_8, [_createVNode(_component_el_descriptions, {
            style: {
              "background": "rgb(14, 45, 73)"
            },
            column: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "告警时间："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.happenedTime), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "告警目标："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.reportNames), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "执行设备："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.deviceName), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "所属部门："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.deptName), 1)]),
              _: 1
            })]),
            _: 1
          })])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).detailInfo.alarmDetail.recognition, (item, index) => {
            return _openBlock(), _createElementBlock("tr", null, [item.type === 101 ? (_openBlock(), _createElementBlock("td", _hoisted_9, [_createVNode(_component_el_descriptions, {
              column: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
                label: "目标："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.reportName) + _toDisplayString(item.label), 1)]),
                _: 2
              }, 1024), item.fireArea ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 0,
                label: "火源面积："
              }, {
                default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.fireArea) + "㎡", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.fireArea.toFixed(0)) + "像素面积", 1))]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), item.firePerimeter ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 1,
                label: "火线长度："
              }, {
                default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.firePerimeter) + "m", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.firePerimeter.toFixed(0)) + "px", 1))]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
                label: "目标经纬度："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.lngLat), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)])) : (_openBlock(), _createElementBlock("td", _hoisted_14, [_createVNode(_component_el_descriptions, {
              column: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
                label: "目标："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.reportName) + _toDisplayString(item.label), 1)]),
                _: 2
              }, 1024), _createVNode(_component_el_descriptions_item, {
                label: "目标经纬度："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.lngLat), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)])), index === 0 && _unref(data).detailInfo.alarmDetail.fireNum > 0 ? (_openBlock(), _createElementBlock("td", {
              key: 2,
              rowspan: _unref(data).detailInfo.alarmDetail.fireNum
            }, [_createVNode(_component_el_descriptions, {
              column: 1
            }, {
              default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
                label: "火源总面积："
              }, {
                default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(data).detailInfo.alarmDetail.fireArea) + "㎡", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(data).detailInfo.alarmDetail.fireArea.toFixed(0)) + "像素面积", 1))]),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "火线总长度："
              }, {
                default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(data).detailInfo.alarmDetail.allFirePerimeter) + "m", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(data).detailInfo.alarmDetail.allFirePerimeter.toFixed(0)) + "px", 1))]),
                _: 1
              })]),
              _: 1
            })], 8, _hoisted_15)) : _createCommentVNode("", true)]);
          }), 256))])])], 544)) : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
            style: {
              "color": "rgba(65,109,143,0.9)"
            }
          }, "未查询到告警信息", -1)]))]))])]),
          _: 1
        })]),
        _: 1
      })])])]);
    };
  }
};